<template>
 <div>
	<el-table :data='newData' stripe style="width: 100%" max-height="400">
		<el-table-column prop="detectionItemClass" label="检测项分类" min-width="90" >
		</el-table-column>
		<el-table-column prop="rsId" label="rsId" min-width="90" >
		</el-table-column>
		<el-table-column prop="gene" label="gene" min-width="105">
		</el-table-column>
		<el-table-column prop="multiMutation" label="是否多种突变" min-width="105">
			<template slot-scope="scope">
				{{scope.row.multiMutation ? '是' :'否'}}
			</template>
		</el-table-column>
		<el-table-column prop="chromosome" label="染色体" min-width="105">
		</el-table-column>
		<el-table-column prop="positionStart" label="起始物理位置" min-width="105">
		</el-table-column>
		<el-table-column prop="positionEnd" label="终止物理位置" min-width="105">
		</el-table-column>
		<el-table-column prop="detectionItemEnglishName" label="检测项英文" min-width="105">
		</el-table-column>
		<el-table-column prop="detectionItemChineseName" label="检测项中文" min-width="105">
		</el-table-column>
		<el-table-column prop="inheritancePattern" label="遗传方式" min-width="105">
		</el-table-column>
		<el-table-column prop="inheritancePatternDb" label="遗传方式来源数据库" min-width="155">
		</el-table-column>
		<!-- <el-table-column prop="chromosome" label="位点与疾病关系的描述" min-width="105">
		</el-table-column> -->
		<el-table-column prop="mutationLevelDois" label="突变等级文献doi号" min-width="145">
		</el-table-column>
		<el-table-column prop="mutationLevelPapers" label="完整突变等级文献" min-width="400" >
		</el-table-column>
		<el-table-column prop="mutationPositionInformation" label="突变位置及信息" min-width="130" >
		</el-table-column>
		<el-table-column prop="paperRank" label="星级" min-width="90" >
		</el-table-column>
		<el-table-column prop="paperLastEvaluationTime" label="最后评估时间" min-width="110" >
		</el-table-column>
		<el-table-column prop="mutationType" label="突变类型" min-width="90" >
		</el-table-column>
		<el-table-column prop="geneHeterozygous" label="杂合基因型" min-width="90" >
		</el-table-column>
		<el-table-column prop="heterozygousFrequency" label="杂合频率" min-width="90" >
		</el-table-column>
		<el-table-column prop="heterozygousSuggestion" label="杂合建议" min-width="200" >
		</el-table-column>
		<el-table-column prop="geneHomozygous" label="纯合基因型" min-width="90" >
		</el-table-column>
		<el-table-column prop="homozygousFrequency" label="纯合频率" min-width="90" >
		</el-table-column>
		<el-table-column prop="homozygousSuggestion" label="纯合建议" min-width="200" >
		</el-table-column>
	</el-table>
</div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      newData: this.tableData
    }
  },
  components: {

  },
  created () {
    console.log('tableData', this.tableData)
  }
}
</script>

<style>

</style>
